var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIotx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00D4D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29194 2.8125V5.88206L11.9571 4.34925L9.29194 2.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M11.9571 4.34937V7.41893L14.6216 5.88218L11.9571 4.34937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.29194 5.88208V8.95164L11.9571 7.41883L9.29194 5.88208ZM11.9571 7.41883V10.4884L14.6216 8.95164L11.9571 7.41883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.29194 8.95166V12.0212L11.9571 10.4884L9.29194 8.95166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9571 10.4883V13.5578L14.6216 12.0211L11.9571 10.4883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.40356 5.77856V8.84813L5.06869 7.31138L2.40356 5.77856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.76562 6.91992V9.98948L8.42625 8.45667L5.76562 6.91992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.79012 8.86108V11.9306L6.45469 10.3939L3.79012 8.86108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M5.54625 11.1775V14.2471L8.20687 12.7103L5.54625 11.1775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.27 12.4988V15.5689L11.9306 14.0316L9.27 12.4988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M6.20943 5.40405V8.47418L8.87006 6.94137L6.20943 5.40405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.29194 2.8125V5.88206L6.62682 4.34925L9.29194 2.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.20943 4.11743V7.18643L3.54375 5.64968L6.20943 4.11743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.87456 5.63623V8.70636L6.20943 7.16904L8.87456 5.63623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M5.75325 6.91992V9.98948L3.08813 8.45667L5.75325 6.91992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.29193 8.95166V12.0212L6.63131 10.4884L9.29193 8.95166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M3.79012 9.6665V12.7361L1.125 11.1988L3.79012 9.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6216 5.88208V8.95164L11.9571 7.41883L14.6216 5.88208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M11.9571 7.41943V10.4884L9.29194 8.95168L11.9571 7.41943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.6216 8.95166V12.0212L11.9571 10.4884L14.6216 8.95166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.9571 10.4883V13.5578L9.29194 12.0211L11.9571 10.4883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.70188 11.7676V14.8371L6.03732 13.3043L8.70188 11.7676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9571 4.34937V7.41893L9.29194 5.88218L11.9571 4.34937Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotx);
export default __webpack_public_path__ + "static/media/iotx.e08e98fd66906cd1a5785b3e5698d200.svg";
export { ForwardRef as ReactComponent };